import { OPEN_USER_PROMPT, CLOSE_USER_PROMPT } from '../actions/actionTypes';
import { USER_PROMPT_MODE } from '../lib/constants';

const appInitialState = {
  showUserPrompt: false,
  promptMessage: '',
  comments: '',
  buttonArray: [],
  onAccept: null,
  mode: USER_PROMPT_MODE.default,
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case OPEN_USER_PROMPT: {
      const promptMessage =
        action.promptMessage || appInitialState.promptMessage;
      const comments = action.comments || appInitialState.comments;
      const buttonArray = action.buttonArray || [];
      const onAccept = action.onAccept || null;
      const mode = action.mode || appInitialState.mode;
      return {
        ...state,
        promptMessage,
        comments,
        buttonArray,
        onAccept,
        showUserPrompt: true,
        mode,
      };
    }
    case CLOSE_USER_PROMPT: {
      return { ...appInitialState };
    }
    default:
      return state;
  }
};
